/// <reference path="../shaka-player.3.3.2.compiled.d.ts" />

module Sxc.Site {

    export class RoomList {
        private _hlsResource = null;
        private _hlsSupport = false;
        private _hlsObject = [];
        private _currentPreiviewPerformer = null;
        //private topchatvisibleinroomlist=false;

        private _configPerPage = 33;
        private _maxpage = 5;

        private currentPage = 1;
        private renderedRoomNum = 0;
        private renderedBigRoomNum = 0;
        private renderedHappyHour = false;
        public fullRoomList = null;
        private autoPagingScrollTop = null;

        private babesHandler = null;
        private roomlist_auto_refresh_seconds = 60;

        public focusedPage = true;
        public lastRandomFreeRoom=null;
        public is_testing=false;

        private lastactive_timout=null;
        private mainpagetitle="";
        private lastrefreshed_ts=0;

        //roomlist params for bigrooms
        private spacebetweenbigrooms=1;
        private bigroomrowsize=2;
        private bigroomcolsize=2;
        private bigroomstartrow=2;
        private promosize=2;
        public click_fanclub=false;
        public click_fanclub_chat=false;
        public click_fanclub_join=false;
        private bigroomverticalrowsize=1;
        private bigroomverticalcolsize=2;

        public consoleLogging=false;

        public canPlayVidWithDash:Boolean=false;
        public shakaPlayer:shaka.Player = null;
        public shakaPlayerTeaser:shaka.Player = null;

        public helpers = null;
        public roomView = null;
        public videoPlayer = null;

        public smallPromoIsOn=true;

        constructor() {
            let thisref=this;
            if(window.location.href.indexOf(".beta.apn2.com")!==-1){this.consoleLogging=true;}

            //konkrét szobára érkezés -> loading panel
            if(window.location.href.indexOf("/mypage/")!==-1){
                $(document).ready(function () {
                    $(".content-loading-roomlist").show();
                    if(window.location.href.indexOf("#fanclub")!==-1){
                        thisref.click_fanclub=true;
                    }else if(window.location.href.indexOf("#chat")!==-1){
                        thisref.click_fanclub_chat=true;
                    }else if(window.location.href.indexOf("#join")!==-1){
                        thisref.click_fanclub_join=true;
                    }
                });
            }

            //Top chat megjelenítése/elrejtése
            //if(!this.topchatvisibleinroomlist){
                $( "<style>.chatroomcont:not(.frame_chat-app-fullscreen),#frame_chat-app:not(.frame_chat-app-fullscreen) .sxcc-tip-after-show-wrapper {display: none !important;}" +
                    "#frame_chat-app:not(.frame_chat-app-fullscreen){top:-10000px;}</style>" ).appendTo( "head" );
            /*}else{
                $( "<style>#main .content-loading {display: none !important;}</style>" ).appendTo( "head" );
            }*/

            this.mainpagetitle=$("title").text();

            thisref.fixpagedownbug();

            $(() => {
                //fix chat at top
                //$(".sxcc-chat-closed .sxcc-chat-inner header").click();
                // @ts-ignore

                this.helpers = new Helpers(thisref);
                // @ts-ignore
                babesHandler = this.babesHandler = new GeneralHandler(thisref,this.helpers);
                this.roomView = new RoomView(thisref);
                this.videoPlayer = new VideoPlayer(thisref);

                Promise.all([
                    // @ts-ignore
                    this.babesHandler.init()
                ]).then(() => {
                    this.joinChat(true);

                    this._hlsResource = "Hls" in window && window["Hls"];
                    this._hlsSupport = this._hlsResource.isSupported();

                    this._loadRoomList();

                    setInterval(() => {
                        if(!this.is_testing && this.current_active_perf_id==-1 && !this.focusedPage){this._loadRoomList(false,true);}
                        }, this.roomlist_auto_refresh_seconds*1000);

                    this._bindPagingLink();

                    $(window).on("blur focusout", () => { this.focusedPage = false; });
                    $(window).on("focus focusin scroll mousemove", () => {
                        this.focusedPage = true;
                        clearTimeout(this.lastactive_timout);
                        this.lastactive_timout=setTimeout(() => {this.focusedPage = false;},this.roomlist_auto_refresh_seconds*1000);
                    });

                    this.setupajaxloader();
                    this.setupScroller();
                    this.setupSettingsHandler();
                    this.setuptopupHandler();
                    this.getFavourites();
                    this.addLastRoomsIfRequiredInterval();
                    this.new_state_checker();
                    this.getRefInfo();
                });
            });


        }

        addedLastRoomsIfRequiredInterval=false;
        addLastRoomsIfRequiredInterval(){
            if(this.addedLastRoomsIfRequiredInterval){return;}
            this.addedLastRoomsIfRequiredInterval=true;
            setInterval(() => {
               //this._addlastrooms_if_required(false,"#roomlist",".room-item","bigroom",".room-mode-vip","",true);
                if(!$(".sxcc-stickers").is(":visible") && !$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                    console.log("addedLastRoomsIfRequiredInterval");
                    $(window).scroll();
                }
            },1000);
        }

        focuser=-1;focusercount=0;
        fixpagedownbug(){
            let thisref=this;
            //focus bug javítása
            // @ts-ignore
            thisref.focuser = setInterval(function () {
                thisref.focusercount++;
                try{$(".sxcc-chat-form-input").blur()}catch (e) {}
                if (thisref.focusercount > 200) {   clearInterval(thisref.focuser);}
            }, 300);

            $("*").click(function () {
                clearInterval(thisref.focuser);
            });
        }

        /**
         * Érkezéskor felső chat ablak incializálása és join
         */
        private mypage_loaded_first=false;
        private default_giftpage_show=false;
        joinChat(first=false){
            let thisref=this;
            //localStorage["setItem"]('sxcChat_uiSize', JSON.stringify('fb'));
            // @ts-ignore
            var chatParams = chatParamsGlobal; chatParams.chatIncludeType = 'babesIFrame';
            chatParams.chatForceWindowHeightFS="400";
            if(window.location.href.indexOf("/mypage/") !==-1){//konkrét szobára érkezés. Szükséges javítás muteolás működési bug hoz
                // @ts-ignore
                if(typeof chatExtra != 'undefined') { chatExtra="force_mute"; }

                if(window.location.href.indexOf("/send_gift")!==-1){thisref.default_giftpage_show=true;}
            }
            // @ts-ignore
            window.chatClient = new ChatClientWrapper(chatParams);
            window['chatClient'].app.view.escIgnoreClose=true;
            if(first){
                if(window.location.href.indexOf("/mypage/")===-1){
                    setTimeout(function() { thisref.registerChatEventHooks("roomlistReloaded"); }, 1);
                } else{ //konkrét szobára érkezés
                    thisref.registerChatEventHooks("app-visible");
                    //setTimeout(function() { window['chatClient'].app.showRoom(null/*, 'param-screenName', 'param-profilePic', {}*/); }, 1);//kell hogy látható legyen
                }
            }

            thisref.registerChatEventHooks("roomHistoryChanged");
            thisref.registerChatEventHooks("app-visible2");
            thisref.registerChatEventHooks("setState");
            thisref.registerChatEventHooks("TipAfterShowHide");
            if(first){ thisref.handleEsc();}
        }

        //checks state periodically to be sure
        new_state_checker(){
            let thisref=this;
            setInterval(() => {
                if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                    let room= thisref.helpers.getCurrentRoomidFromChat();
                    $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+room+'&onlyforstatuscheck=1', dataType: 'json'}).done((dataJson) => {
                        if(typeof dataJson["onlinestatus"]!== "undefined"){
                            console.log("Currstatus: "+dataJson["onlinestatus"]);
                            if(
                                dataJson["onlinestatus"] === "free" && window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("freeShow")
                                || dataJson["onlinestatus"] === "offline" && window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("offline")
                                || dataJson["onlinestatus"] === "vip" &&
                                        (
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("groupShow") &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("voyeurShow") &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("groupLobby")
                                        )

                                || (
                                    (dataJson["onlinestatus"] === "private" || dataJson["onlinestatus"] === "priv" || dataJson["onlinestatus"] === "exclusive") &&
                                        (
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("exclusiveShow") &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("privateShow")  &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("privateLobby") &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("exclusiveLobby") &&
                                        window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("voyeurShow")
                                        )
                                )
                            ){
                                if(window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("bannedFromRoom") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("outOfCredit") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("autoNextRoom") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("error") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("pause") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("init") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("idle") &&
                                    window['chatClient'].app.getState() !== window['chatClient'].app.getAppStateEnum("technical")
                                    ){
                                        window['chatClient'].app.reset(() => {
                                            console.log("Resetting, prev status: "+dataJson["onlinestatus"]);
                                            // @ts-ignore
                                            let room= thisref.helpers.getCurrentRoomidFromChat();
                                            window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                                            window['chatClient'].app.showRoom(room);
                                        });
                                }
                            }
                        }
                        // @ts-ignore
                        if(__isLoggedMember  === true && typeof dataJson["lonvenseStatus"]!== "undefined"){
                            if(dataJson["lonvenseStatus"]=="1" && !$(".sxccp-smarttips-wrapper").is(":visible")){
                                window['chatClient'].app.view.specialGiftPanel.performerChanged({roomid: "34061",onlineParams:{publicData:{lovenseOnline:"1"}}});
                            }else if(dataJson["lonvenseStatus"]=="0" && $(".sxccp-smarttips-wrapper").is(":visible")){
                                window['chatClient'].app.view.specialGiftPanel.performerChanged({roomid: "34061",onlineParams:{publicData:{lovenseOnline:"0"}}});
                            }

                        }
                    });
                }
            }, 20000);

        }

        /**
         * Chat event hookok regisztrálása
         */
        private observerleftright=null;
        private firstcredit=null;
        private aftererror_ts=-1;
        private lastPaidSessionStarted = 0;
        private lastPaidSessionPerfId = 0;
        public registerChatEventHooks(eventname){
            let thisref=this;

            //azonos streamek mellőzése
            if(eventname=="roomHistoryChanged"){ //mindig lefut
                window['chatClient'].app.event.on(eventname, function() {
                    let interval=setInterval(function() { thisref.stopStreamIfRunMain(); $(window).trigger('resize'); }, 650);
                    setTimeout(function () { clearInterval(interval);  },8000);

                    //media gallery, profile
                    if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen") || (!thisref.mypage_loaded_first && window.location.href.indexOf("/mypage/")!==-1)){
                        $(".sxcc-user-data").html("");
                        let currentroomid=thisref.helpers.getCurrentRoomidFromChat();
                        if(currentroomid!=null){
                            setTimeout(() => { thisref.roomView.roomgallery.addUserDataFrame(currentroomid); }, 1);//e.helpers.log("roomHistoryChanged "+currentroomid);
                        }else if(window.location.href.indexOf("/mypage/")!==-1){
                            let arr1=window.location.href.split("/mypage/");let arr2=arr1[1].split("/");
                            let perfid=(arr2[0].split("?"))[0];
                            setTimeout(() => { thisref.roomView.roomgallery.addUserDataFrame(perfid); }, 1);
                        }
                    }

                    //ha nincs top chat betöltés után reset, ha roomlsit van
                    if(/*!thisref.topchatvisibleinroomlist &&*/ !$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){window['chatClient'].app.reset();}

                    //this.helpers.log("roomHistoryChanged"+new Date().getTime());
                });
            }else if(eventname=="app-visible"){//konkrét szobára érkezés esetén
                window['chatClient'].app.event.on(eventname, function(visible) {
                    if(/*visible &&*/ !thisref.mypage_loaded_first && window.location.href.indexOf("/mypage/")!==-1){
                        setTimeout(function() {thisref.mypage_loaded_first=true;thisref.roomView._openPerformerFullscreen(null);}, 1);
                    }
                });
            }else if(eventname=="TipAfterShowHide"){
                window['chatClient'].app.event.on(eventname, () => {
                    thisref.roomView._closeChatFuncRoomlist();
                });
            }else if(eventname=="roomlistReloaded"){
                window['chatClient'].app.event.on(eventname, function() {
                    if(!thisref.mypage_loaded_first){//főoldalra érkezés érkezés esetén, de csak egyszer fut le változó segítségével
                        thisref.mypage_loaded_first=true;
                        //if(thisref.topchatvisibleinroomlist && !$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){thisref.joinRandomRoom();}
                        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
                        $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(function(){thisref.roomView._closeChatFuncRoomlist();});
                    }
                });
            }else if(eventname=="app-visible2"){
                //globális, szükséges a topup panel és a design megfelelő működéséhez
                window['chatClient'].app.event.on("app-visible", function(visible) {
                    $(window).trigger('resize');
                    if(visible){ $("#wait_chat").hide();}
                    else{ $("#wait_chat").show(); }

                    //set up scroller for small stream and click event
                    thisref.setupScroller(false);
                    $(".sxcc-obj-wrapper").click(function(){
                        if(!$(this).hasClass("in-newpopup") && $(this).hasClass("sxccs-float-over-reg") && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                            $(".sxc-chat").animate({ scrollTop:0}, 1);
                            $([document.documentElement, document.body]).animate({scrollTop: $("#frame_chat-app").offset().top }, 1);
                            $(window).scroll();
                        }
                    });

                    //Firstcredit promo jalzése SecurionPay JS objektumnak a megfelelő fizetési ikonra kattintáskor
                    thisref.firstcredit = new MutationObserver(function(mutations) {
                        if($(".sxcc-topup-panel").hasClass("sxc-visible")){
                            $(".sxcct-amt-item").click(function(){
                                if($(this).hasClass("sxcct-amt-item-promo-firstcredit")){
                                    securionPayHandler.creditcard.firstCreditPromo=true;
                                }else{
                                    securionPayHandler.creditcard.firstCreditPromo=false;
                                }
                            });
                        }
                    });
                    thisref.firstcredit.observe($('.sxcc-topup-panel')[0], {  attributes: true   });
                });
            }else if(eventname=="setState"){
                //globális, szükséges pl. a teaser videók automatikus elindításához
                window['chatClient'].app.event.on(eventname, function(currentState,lastState) {
                    thisref.helpers.log("currentState:"+ currentState);
                    thisref.observerleftright = null;

                    // After Paid show notifer
                    // @ts-ignore
                    if(__isLoggedMember  === true) {
                        if (currentState == window['chatClient'].app.getAppStateEnum("groupShow") || currentState == window['chatClient'].app.getAppStateEnum("privateShow") || currentState == window['chatClient'].app.getAppStateEnum("voyeurShow") || currentState == window['chatClient'].app.getAppStateEnum("exclusiveShow")) {
                            thisref.lastPaidSessionStarted = new Date().getTime();
                            thisref.lastPaidSessionPerfId = thisref.helpers.getCurrentRoomidFromChat();
                        } else {
                            if (thisref.lastPaidSessionStarted > 0 && new Date().getTime() - thisref.lastPaidSessionStarted > 1000 * 5 * 60) {
                                $.get("/api/v2/systemMessages/sendAfterPrivateNotification",
                                    {ajax: "1", perfid: thisref.lastPaidSessionPerfId}, function (data) { });
                            }
                            thisref.lastPaidSessionStarted = 0;
                        }
                    }

                    if((currentState == window['chatClient'].app.getAppStateEnum("offline") || currentState == window['chatClient'].app.getAppStateEnum("autoNextRoom")) && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen") && thisref.roomView.marker_for_hide_chat_if_needed){//ha offline
                        //thisref.roomView.destroyLovense();
                        //chat notifikáció eltűntetése
                        /*$(".sxcc-toast-wrapper").hide();
                        $(".sxcc-toast-wrapper").removeClass("sxc-visible");
                        setTimeout(function () { $(".sxcc-toast-wrapper").show();   },2000);
                        thisref.mypageHideTopChat(currentState == 1 << 17); // 1<<17: autoNextRoom started -> so we call reset to stop timer

                        $(".frame-content .frame-paging .nav").css("top","50%");//balra jobbra nyilak chathez képes horizontálisan középre
                        */
                    }else if((currentState== window['chatClient'].app.getAppStateEnum("idle")  || currentState== window['chatClient'].app.getAppStateEnum("init") ) && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){//reset Ilde elnyelése
                    }
                    else if(currentState== window['chatClient'].app.getAppStateEnum("technical") || currentState== window['chatClient'].app.getAppStateEnum("error") ){//technical error or error
                        console.error("technical error");
                        //thisref.roomView.destroyLovense();
                        //automatikus újracsatlakozás kiszedve
                        /*let room= thisref.helpers.getCurrentRoomidFromChat();
                        $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+room, dataType: 'json'}).done((dataJson) => {
                            if(typeof dataJson["onlinestatus"]!== "undefined"){
                                if(dataJson["onlinestatus"]!="offline" && dataJson["roomMode"]!="pause"){
                                    thisref.aftererror_ts=setInterval(()=>{
                                        window['chatClient'].app.reset(() => {
                                            // @ts-ignore
                                            let room= thisref.helpers.getCurrentRoomidFromChat();
                                            window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                                            window['chatClient'].app.showRoom(room);
                                        });
                                    },4000);
                                }
                            }
                        });*/
                    }
                    else{
                        try{clearInterval(thisref.aftererror_ts);}catch (err){}
                        thisref.roomView.mypageShowTopChat();
                        $("#video-player-teaser-cont").html("");
                        $(".sxcc-wrapper").removeClass("teaseron");
                        $(window).resize();
                    }

                    //hide loading if mobile view
                    thisref.helpers.log();
                    if(window['chatClient'].app.isMobileView() &&
                        (currentState===window['chatClient'].app.getAppStateEnum("freeShow") || currentState===window['chatClient'].app.getAppStateEnum("groupShow") || currentState===window['chatClient'].app.getAppStateEnum("privateShow") || currentState===window['chatClient'].app.getAppStateEnum("voyeurShow")
                            || currentState===window['chatClient'].app.getAppStateEnum("privateLobby") || currentState===window['chatClient'].app.getAppStateEnum("exclusiveLobby") || currentState===window['chatClient'].app.getAppStateEnum("exclusiveShow") || currentState===window['chatClient'].app.getAppStateEnum("groupLobby") || currentState===window['chatClient'].app.getAppStateEnum("offline"))){
                        setTimeout(() => {//ugrálás csökkentése végett
                            if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){$(".content-loading-roomlist.chat-show").hide();}
                        }, 1); //ugáráls csökkentés ideiglenesen offolva
                    }
                });
            }
        }





        /**
         * Esc gomb lekezelése
         */
        public handleEsc(){
            let thisref=this;
            $(window).on("keydown", e =>{
                if (e.keyCode === 27 && !$(".fancybox-container").is(":visible") && !$(".popup").is(":visible")
                    && !$(".sxcc-tip-after-show-wrapper").is(":visible") && !$(".sxcc-topup-panel").is(":visible")
                    && !$("#perfsearch").is(":visible") && !$(".sxcc-auth-panel-wrapper").is(":visible") && !$(".sxcc-gift-panel").hasClass("sxc-visible")){
                        if($(".chatroomcont").is(":visible")){
                            thisref.roomView._closeChatFuncRoomlist();
                        }else if($("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                            thisref.roomView._closeChatFuncOpenedRoom(null,true,true);
                        }
                }
                if (e.keyCode === 27 && $("#perfsearch").is(":visible")){
                    setTimeout(function() {$("#perfsearch").hide();  }, 1);
                }
            });
        }


        /**
         * Stream leállítása, ha a fő caht ablakba is fut
         */
        stopStreamIfRunMain(){
            let currentroomid= this.helpers.getCurrentRoomidFromChat();
            if(currentroomid !== null && $("#video_"+currentroomid).hasClass("auto-preview") && this.current_active_perf_id!=currentroomid){
                this.helpers.log("tryleave0 stopStreamIfRunMain:"+currentroomid);
                this._bindStreamPreviewLeave( currentroomid,true);
                if(typeof this.lastRandomFreeRoom!=="undefined" && this.lastRandomFreeRoom!=null && currentroomid!=this.lastRandomFreeRoom.roomid){
                    this.helpers.log("tryleave0 stopStreamIfRunMain/2:"+this.lastRandomFreeRoom.roomid);
                    this._bindStreamPreviewLeave(this.lastRandomFreeRoom.roomid,true);
                }
            }
        }

        /**
         *  Scroll events
         */
        mianscrollerts=0;
        setupScroller(main=true){
            let thisref=this;
            if(main){
                $(window).scroll(() => {
                    //Infinite Scroll beállítása
                    if($(window).scrollTop() + $(window).height() >=  $('footer').offset().top - 220 ) {
                        $('.roomlist-paging').trigger('click');
                    }

                    //kicsinyítés törlése, ha register popup után beragadt
                    if($(window).scrollTop()  <=  $('.sxcc-stream').height()    && !$(".sxcc-auth-panel-wrapper").hasClass("sxc-visible") && $(".newpopup").hasClass("hidden"))
                    {
                        $(".sxcc-obj-wrapper:not(.in-newpopup)").removeClass("sxccs-float-over-reg");
                    }
                });
            } else {
                const handleScroll = view => () => {

                    view = $(".sxc-chat").hasClass("sxcc-size-fb")?"fb":"normal";
                    const $chat = $(".sxc-chat");
                    const $objWrapper = $(".sxcc-obj-wrapper:not(.in-newpopup)");
                    //const scrollTop = view == "normal" ? $chat.scrollTop() : $(window).scrollTop();
                    const scrollTop =$(window).scrollTop();
                    const className = view == "normal" ? "sxcc-size-normal" : "sxcc-size-fb";
                    const stateMatches = [
                        1 << 7,
                        1 << 8,
                        1 << 9,
                        1 << 10,
                        1 << 13

                    ].indexOf(window['chatClient'].app.currentState)!==-1;

                    if ($chat.hasClass(className) && $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")
                        && !$(".sxcc-auth-panel-wrapper").hasClass("sxc-visible") && !$(".newpopup").hasClass("hidden") ) {

                        if (!$(".sxcc-stream-wrapper").hasClass("hidden")
                            && scrollTop >= $(".sxcc-stream").height()
                            && stateMatches) {
                            $objWrapper.addClass("sxccs-float-over-reg");
                        } else {
                            $objWrapper.removeClass("sxccs-float-over-reg");
                        }
                    }
                };


                //$(".sxc-chat").scroll(handleScroll("normal"));

                $(window).scroll(handleScroll("fb"));
            }
        }

        /**************************************************************************/

        /**
         * Settings ablak mentések utáni múveletek
         */
        setupSettingsHandler(){
            let thisref=this;
            $(document).ajaxComplete(function(event,request,settings){
                //roomlista frissítése filterek mentésekor
                if ( (settings.url.indexOf("ajax/myaccount/livefilter")!==-1 ||  settings.url.indexOf("ajax/myaccount/roomlist")!==-1 ) && settings.type=="POST" && !thisref.roomlistisloading) {
                    thisref._loadRoomList(true,false,true);
                }

                //fix chat at top
                //$(".sxcc-chat-closed .sxcc-chat-inner header").click();

                //keresési találatok klikk bind
                $("#perfsearch .results a").click(function (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
                    $("#perfsearch").hide();
                    let arr1=$(this).attr("href").split("/mypage/");let arr2=arr1[1].split("/");
                    thisref.roomView._openPerformerFullscreen({"perfid":arr2[0],"screenname":"","roomimgid":""});
                });
            });
        }

        /**************************************************************************/

        /**
         * Kreditfeltöltéssel kapcsolatos múveletek
         */
        setuptopupHandler(){
            let that=this;
            $(document).ready(function () {
                $("#topupmenu").click(() => {
                    that.babesHandler._checkHappyHourPromo(true);//fontos a sorrend utána a show()
                });
            });
        }

        /**************************************************************************/

        /**
         * Ajax loader hozzáadása
         */
        setupajaxloader(){
            $(document).ajaxSend(function(event, jqxhr, settings){
                if( $("#wait").length==0){
                    $('<div id="wait" style="display:none;position:absolute;z-index:99999;margin: auto; top: 0;left: 0; right: 0; bottom: 0;height:80px;width:80px;" ><div class="lds-ellipsis"></div></div>').appendTo($('body' ));
                }
                if(settings.url.indexOf("ajax=1")!==-1){
                    if( $('#wait').parent()!=$("body")){
                        $('#wait').css("position","fixed");
                        $('#wait').appendTo($('body'));
                    }
                    $("#wait").show();
                    $('#wait').css("display","block");
                }
            });
            $(document).ajaxComplete(function(event, jqxhr, settings){
                if(settings.url.indexOf("ajax=1")!==-1){
                    $("#wait").hide();
                }
            });
        }

        /**************************************************************************/

        /**
         * Szoba lista betöltése
         */
        public roomlistisloading=false;
        private nicereloading_in_progress=false;
        public _loadRoomList(forced=false,nicereload=false,forcedrender=false) {
                if($('#roomlist').find('li').length > 0 && this.focusedPage === true && !forced) { return; }
                if(!$("section.onlineroom-section").is(":visible") || this.nicereloading_in_progress || this.roomlistisloading || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){return;}
                this.roomlistisloading=true;
                if(nicereload){this.nicereloading_in_progress=true;$(".roomlist-paging").hide();}

                this.renderedRoomNum = 0;
                this.renderedBigRoomNum = 0;

                this._getRoomList().then(() => {
                    this.lastrefreshed_ts=new Date().getTime();

                    this.autoShowRegisterPanel();

                    /*if($('#roomlist').find('li').length > 0) {
                        $('#roomlist').css('min-height', $('#roomlist').height());
                    }*/

                    $('#roomlist'+(nicereload?"_preload":"")+' li').remove();
                    this._renderHappyHourPromo()
                        .then(() => {
                            this._renderRoomList(nicereload,forcedrender);
                            this.roomlistisloading=false;
                            this._startRoomPictureTimer();
                            if(nicereload){ this._replaceRoomsNice(); }
                        });
                });
        }
        /**************************************************************************/

        /**
         * Szobalista frissítése animációkkal
         */
        private timeout_addlast=-1;
        _replaceRoomsNice() {
            let thisref=this;
            let preitems=$("#roomlist_preload li.room-item:not(.hidden)");
            if(preitems.length<=6){return;}
            let preitems_length_at_start=preitems.length;
            let olditems=$("#roomlist li.room-item:not(.hidden)");
            let olditems_length_at_start=olditems.length;

            let i=0; preitems.each(function () {   $(this).attr("data-nth",i+"");i++; });
            i=0; olditems.each(function () {   $(this).attr("data-nth",i+"");i++; });
            for(i=0;i<olditems.length;i++){
                //preitems.eq(i).fadeOut();
                if (olditems.eq(i).hasClass("bigroom")) {
                    preitems.eq(i).addClass("bigroom").addClass("brready")
                        .attr("style", olditems.eq(i).attr("style"))
                        .attr("data-col", olditems.eq(i).attr("data-col"))
                        .attr("data-row", olditems.eq(i).attr("data-row"));
                }
            }
            this.replaceFirstXBigroomToPremium(2,"#roomlist_preload");
            let iii=0;

            let idozitoarr=[];
            for(iii=0;iii<preitems.length;iii++) {idozitoarr.push(iii);}
            idozitoarr=idozitoarr.reverse();
            //idozitoarr=this.helpers.shuffle(idozitoarr);
            for(iii=0;iii<preitems.length;iii++) {
                setTimeout(function(iii){
                    if( $("#roomlist li.room-item[data-nth='" + iii + "']").length>0){
                        thisref.helpers.log("tryleave0 _replaceRoomsNice:"+ $("#roomlist li.room-item[data-nth='" + iii + "']").data('perfid'));
                        thisref._bindStreamPreviewLeave( $("#roomlist li.room-item[data-nth='" + iii + "']").data('perfid'),true);
                        $("#roomlist li.room-item[data-nth='" + iii + "'] .room-inner").css("z-index","4");
                        $("#roomlist_preload li.room-item[data-nth='" + iii + "'] .room-inner").clone().appendTo("#roomlist li.room-item[data-nth='" + iii + "'] .room");
                        $("#roomlist li.room-item[data-nth='" + iii + "'] .room-inner:first").animate({ opacity: 0 }, 800,function () {
                            let ii=$(this).closest("li.room-item").attr("data-nth");
                            //$("#roomlist_preload li.room-item[data-nth='" + ii + "']").css("opacity","0.5");
                            if($("#roomlist li.room-item[data-nth='" + iii + "']").length>0){
                                $("#roomlist li.room-item[data-nth='" + iii + "']").first().replaceWith($("#roomlist_preload li.room-item[data-nth='" + ii + "']"));
                                //$("#roomlist li.room-item[data-nth='" + ii + "']:not(:first)").remove();
                                //--$("#roomlist li.room-item[data-nth='" + ii + "']").animate({ opacity: 1 }, 800);
                                thisref._StartStreamsRandom();
                                try{clearTimeout(thisref.timeout_addlast);}catch (e) {}
                                // @ts-ignore
                                thisref.timeout_addlast=setTimeout(function () { thisref.nicereloading_in_progress=false;thisref._addlastrooms_if_required();},800);
                            }
                            //thisref._remove_duplicate_rooms();
                        });
                    }else{
                        $("#roomlist_preload li.room-item[data-nth='" + iii + "']").css("opacity","0");
                        $("#roomlist_preload li.room-item[data-nth='" + iii + "']").insertAfter($("#roomlist li.room-item:last"));
                        $("#roomlist li.room-item[data-nth='" + iii + "']").show();
                        $("#roomlist li.room-item[data-nth='" + iii + "']").animate({ opacity: 1 }, 2000);
                        //thisref.helpers.log("added new");
                        thisref._StartStreamsRandom();
                        try{clearTimeout(thisref.timeout_addlast);}catch (e) {}
                        // @ts-ignore
                        thisref.timeout_addlast=setTimeout(function () { thisref.nicereloading_in_progress=false;thisref._addlastrooms_if_required();},800);

                    }
                },4000+(idozitoarr.pop())*100,iii);
            }
            //Ha több jön, mint előzőleg volt
            /*let morepreitems=$("#roomlist_preload li.room-item:not(.hidden)");
            let actualitems=$("#roomlist li.room-item:not(.hidden)");
            if(  morepreitems.length>0){
                for(iii=actualitems.length;iii< olditems.length+ morepreitems.length;iii++) {
                    setTimeout(function(iii){
                        $("#roomlist_preload li.room-item[data-nth='" + iii + "']").css("opacity","0");
                        $("#roomlist_preload li.room-item[data-nth='" + iii + "']").insertAfter($("#roomlist li.room-item:last"));
                        $("#roomlist li.room-item[data-nth='" + iii + "']").show();
                        $("#roomlist li.room-item[data-nth='" + iii + "']").animate({ opacity: 1 }, 2000);
                        thisref._StartStreamsRandom();
                    },2000+olditems.length+iii*100,iii);
                }
            }*/
            //ha kevesebb jön, mint ami volt
            idozitoarr=[];
            let ii2=1;
            for(iii=preitems_length_at_start;iii< olditems_length_at_start;iii++)  {idozitoarr.push(ii2);ii2++;}
            idozitoarr=idozitoarr.reverse();
            if(  preitems_length_at_start<olditems_length_at_start && preitems_length_at_start>10){
                thisref.helpers.log("needs removing pre:"+preitems_length_at_start+" old:"+olditems_length_at_start);
                for(iii=preitems_length_at_start;iii< olditems_length_at_start;iii++) {
                    $("#roomlist li.room-item:not(.removing):last").addClass( "removing"+iii).addClass( "removing");
                    setTimeout(function(iii){
                        $("#roomlist li.room-item.removing"+iii).animate({ opacity: 0 }, 2000,function () {
                            $(this).remove();
                            try{clearTimeout(thisref.timeout_addlast);}catch (e) {}
                            // @ts-ignore
                            thisref.timeout_addlast=setTimeout(function () {
                                thisref.nicereloading_in_progress=false;
                                thisref._addlastrooms_if_required();
                                },800);
                        });
                    },4000+(idozitoarr.pop())*100,iii);
                    //if(iii>=10){break;}
                }
            }
        }

        /**************************************************************************/

        /**
         * Szobalista utolsó elemeinek kipótlása, ha vannak "hézagok" a végén
         */
        private addinglastrooms=false;
        public _addlastrooms_if_required(instant=false,mainelement="#roomlist",childelement=".room-item",bigroomclass="bigroom",viproomsel=".room-mode-vip",sordbMainElement="") {
            let sordb=this._getColcountPerRow((sordbMainElement==""?mainelement:sordbMainElement)+' '+childelement+'');
            if(sordb==1 || (this.currentPage!=this._maxpage+1 && mainelement=="#roomlist") || (this.nicereloading_in_progress && mainelement=="#roomlist") || this.addinglastrooms || ((!$("section.onlineroom-section").is(":visible") || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")) && mainelement=="#roomlist")
                || (this.nicereloading_in_progress && instant && mainelement=="#roomlist") || (mainelement!="#roomlist" && $("section.onlineroom-section").is(":visible")) ){return;}
            this.helpers.log("_addlastrooms_if_required "+instant+" "+mainelement);
            this.addinglastrooms=true;
            let thisref=this;

            //először duplikátumok eltávolítása ha van valamely oknál fogva
            if(mainelement=="#roomlist"){
                $(mainelement+" li.duplicate").each(function () {
                    thisref.helpers.log("tryleave0 _addlastrooms_if_required:"+($(this).data('perfid')));
                    try{thisref._bindStreamPreviewLeave($(this).data('perfid'),true);}catch(e){}
                    $(this).remove();
                });
            }
            if(instant && mainelement=="#roomlist"){thisref._remove_duplicate_rooms();}
            if(mainelement=="#roomlist"){thisref._remove_duplicate_rooms();}

            let roomslen=$(mainelement+" li"+childelement+":not(."+bigroomclass+",.hidden)").length;
            let bigroomslen=($(mainelement+" li"+childelement+"."+bigroomclass+":not(.hidden):not(."+bigroomclass+"-vertical)").length*(this.bigroomrowsize*this.bigroomcolsize));
            let bigroomsvertlen=($(mainelement+" li"+childelement+"."+bigroomclass+"-vertical:not(.hidden)").length*(this.bigroomverticalrowsize*this.bigroomverticalcolsize));
            let poromoslen=($(mainelement+" li.happy-hour-promo").length*this.promosize+($(mainelement+" li.small-promo").length));
            let diff=(roomslen+bigroomslen+poromoslen+bigroomsvertlen)%sordb;

            //last bigroom fix
            let rows=(roomslen+bigroomslen+poromoslen+bigroomsvertlen)/sordb;
            let bigrooms=$(mainelement+" li."+bigroomclass+":not(.hidden)");
            let needtoaddspecial=0;
            if(bigrooms.length>0 && parseInt(bigrooms.last().css("grid-row-start"))>=rows && this.bigroomcolsize<sordb){
                needtoaddspecial=(this.bigroomcolsize*sordb)-(this.bigroomrowsize*this.bigroomcolsize);
                bigrooms.last().attr("data-fixed-bigroom","true");
                //bigrooms.last().removeClass(bigroomclass).removeClass(bigroomclass+"-vertical");
            }

            this.helpers.log("Addlastrooms: ("+mainelement+" "+ childelement+") Rooms: "+roomslen+" Bigrooms: "+bigroomslen+" Bigroomsvert: "+bigroomsvertlen+" Promos: "+poromoslen+" All: "+(roomslen+bigroomslen+poromoslen)+" sordb: "+sordb + "Diff:"+diff +"needtoaddspecial:"+needtoaddspecial);

            //add more if needed
            if((diff!==0 || needtoaddspecial!=0)){
                let needtoadd=sordb-diff;
                if(needtoaddspecial!=0){needtoadd=needtoadd+needtoaddspecial;}
                for(let iii=0;iii< needtoadd;iii++) {
                    let elem=$(mainelement+" li"+childelement+""+viproomsel+":not(."+bigroomclass+",.hidden)").eq(iii).clone();
                    let classes=elem.attr("class").split(" ");
                    let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf(childelement+"-") != -1});
                    let theclass=theclassarr[0];

                    elem.css("opacity","0");
                    elem.insertAfter($(mainelement+" li"+childelement+":last"));
                    elem.find("a[href*='/mypage/']").click(function () {
                        $(mainelement+" li."+theclass+":not(.duplicate)").first().find("a[href*='/mypage/']").click();
                    });
                    if(mainelement.indexOf("fanclub") !== -1){
                        elem.find("a").click(function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            $(mainelement+" li[data-id='"+$(this).closest(".mg-item").attr("data-id")+"']").first().find("a").click();
                        });
                        elem.find("img").attr("src", elem.find("img").attr("data-src"));
                    }
                    elem.find(".event-overlay").click(function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
                            $(mainelement+" li[data-id='"+$(this).closest(".mg-item").attr("data-id")+"']").first().find(".event-overlay").click();
                    });
                    elem.find("a.favorite").click(function () {
                        $(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.favorite").click();
                    });
                    elem.find("a.sound").click(function () {
                        try{$(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.sound").click();}catch (e) { }
                        $(this).attr("class",$(mainelement+" li."+theclass+":not(.duplicate)").first().find("a.sound").attr("class"));
                    });
                    elem.addClass("duplicate");
                    if(instant){elem.css("opacity","1");}
                    else{elem.animate({ opacity: 1 }, 500);}
                }
            }
            if(instant){this.addinglastrooms=false;}
            else{
                setTimeout(function () { thisref.addinglastrooms=false;},1800);
            }

            //ha valamely feketelistás valamiért bigroom
            if(mainelement=="#roomlist"){
                this.replaceBlacklistBigroomToNotBlackilst();
            }

            /*if(thisref.currentPage>thisref._maxpage){
                $(".roomlist-paging").show();
            }*/
        }

        /**
         * Feketelistás Bigroom cseréje
         */
        replaceBlacklistBigroomToNotBlackilst(selectorroomlist="#roomlist") {
            let oldelements=$(selectorroomlist+" .room-item.bigroom[data-achivements*='blacklist']");
            oldelements.each(function() {
                let old = $(this);
                let colorig = old.attr("data-col");
                let roworig = old.attr("data-row");
                let news = $(selectorroomlist + " .room-item:not(.bigroom)").not("[data-achivements*='premium']").not("[data-achivements*='blacklist']");
                if (news.length > 0) {
                    let new1 = news.first();
                    //replace
                    new1.css("grid-column-start", colorig);
                    new1.attr("data-col", colorig);
                    new1.css("grid-row-start", roworig);
                    new1.attr("data-row", roworig);
                    new1.addClass("bigroom");
                    new1.find("img:first").attr('src', new1.new("img:first").attr("data-big-img"));
                    old.removeAttr("style");
                    old.removeAttr("data-col");
                    old.removeAttr("data-row");
                    old.removeClass("bigroom");
                }
            });
        }


        /**************************************************************************/

        /**
         * Szobalista duplikátumok eltávolítása
         */
        _remove_duplicate_rooms(only_pre=false) {
            let thisref=this;

            if(!only_pre){
                $("#roomlist li.room-item:not(.hidden)").each(function () {
                    let classes=$(this).attr("class").split(" ");
                    let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf("room-item-") != -1});
                    let theclass=theclassarr[0];
                    if($("#roomlist ."+theclass+":not(.duplicate)").length>1){
                        thisref.helpers.log("tryleave0 _remove_duplicate_rooms:"+$("#roomlist ."+theclass+":last").data('perfid'));
                        thisref._bindStreamPreviewLeave($("#roomlist ."+theclass+":last").data('perfid'),true);
                        $("#roomlist ."+theclass+":not(.duplicate):not(:first)").remove();
                    }
                });
            }

            $("#roomlist_preload li.room-item:not(.hidden)").each(function () {
                let classes=$(this).attr("class").split(" ");
                let theclassarr = jQuery.grep(classes, function(value, i) {return value.indexOf("room-item-") != -1});
                let theclass=theclassarr[0];
                if($("#roomlist_preload ."+theclass+":not(.duplicate)").length>1 ){
                    thisref.helpers.log("tryleave0 _remove_duplicate_rooms/2:"+$("#roomlist ."+theclass+":last").data('perfid'));
                    thisref._bindStreamPreviewLeave($("#roomlist ."+theclass+":last").data('perfid'),true);
                    $("#roomlist_preload ."+theclass+":not(.duplicate):not(:first)").remove();
                }
            });
        }

        /**************************************************************************/

        /**
         * Promocis banner hozzadasa
         */
        _renderHappyHourPromo(responseJSONParam = null) : Promise<void> {
            let _thisObj = this;

            return new Promise<void>((resolve, reject) => {
                try {
                    if(responseJSONParam!=null){
                        onreadycall(responseJSONParam);
                        resolve();
                    }else{
                        this.babesHandler._checkHappyHourPromo(false,true);

                        resolve();
                        /*$.ajax({
                            url      : '/ajax/api/getPromos',
                            type     : 'GET',
                            dataType : 'json',
                            data     : {}
                        }).done((responseJSON) => {
                            onreadycall(responseJSON);
                            resolve();
                        });*/
                    }
                } catch(ex) { console.error(ex); reject(); }
            });

            function onreadycall(responseJSON){
                _thisObj.renderedHappyHour = responseJSON.result;

                //Happy Hour Promo
                if(responseJSON.result === true && $('#roomlist .happy-hour-promo').length==0) {
                    // @ts-ignore
                    let imgElement = $('<img>').attr('src', '/design/default/babes/images/promo/happyhour/echh_'+(responseJSON.extraCredit.bonus || 25)+'_'+__currLang+(responseJSON.extraCredit.hhimg_pfix || '')+'.jpg?v=1498764525');
                    let aElement = $('<a>').attr('href', 'javascript:void(0)');
                    aElement.click((e) => {
                        // @ts-ignore
                        if(__isLoggedMember === true) {
                            _thisObj.babesHandler._checkHappyHourPromo(true);//fontos a sorrend utána a show()
                        }
                        else{ _thisObj.babesHandler.showPopup('loginpop'); }
                    });
                    aElement.append(imgElement);
                    let liElement = $('<li>').addClass('promo').addClass('happy-hour-promo').append(aElement);
                    $('#roomlist').prepend(liElement);
                    _thisObj._addlastrooms_if_required(true);
                } else if(responseJSON.result === false) {
                    try{clearTimeout(_thisObj.babesHandler.hhour_timeout);}catch(ex){}
                    // @ts-ignore
                    try{securionPayHandler.promo.clearPromo();}catch (e) {}
                    if($ ('#roomlist .happy-hour-promo').length>0){
                        $('#roomlist .happy-hour-promo').remove();
                        _thisObj._addlastrooms_if_required(true);
                    }
                }

                //TopRight Promo
                if(responseJSON.result_topright === true && $('#roomlist .top-right-promo').length==0) {
                    // @ts-ignore
                    let imgElement = $('<img>').attr('src', '/design/default/babes/images/topright-promo/topright_'+__currLang+'.jpg?v=1498764525');
                    let aElement = $('<a>').attr('href', 'javascript:void(0)');
                    aElement.click((e) => {
                        // @ts-ignore
                        if(__isLoggedMember === true) { window["chatClient"].app.view.topupPanel.show(); }
                        else{ _thisObj.babesHandler.showPopup('loginpop'); }
                    });
                    aElement.append(imgElement);
                    let liElement = $('<li>').addClass('promo').addClass('top-right-promo').append(aElement);
                    $('#roomlist').prepend(liElement);
                    _thisObj._addlastrooms_if_required(true);
                } else if(responseJSON.result_topright === false) {
                    try{clearTimeout(_thisObj.babesHandler.hhour_timeout);}catch(ex){}
                    // @ts-ignore
                    try{securionPayHandler.promo.clearPromo();}catch (e) {}
                    if($ ('#roomlist .top-right-promo').length>0){
                        $('#roomlist .top-right-promo').remove();
                        _thisObj._addlastrooms_if_required(true);
                    }
                }

                //Small banner Promo
                _thisObj._rendersmallPromo(_thisObj,responseJSON);

            }
        }

        public refInfo = {};
        getRefInfo(){
            let thisref = this;
            $.ajax({ url : '/ajax/api/getSmallPromo?ownData=1',  type     : 'GET',   dataType : 'json',  data : {}
            }).done((responseJSON) => {
                thisref.refInfo = responseJSON;
            });
        }

        _opensmallPromo(){
            $.ajax({ url : '/ajax/api/getSmallPromo',  type     : 'GET',   dataType : 'json',  data : {}
            }).done((responseJSON) => {
                $("#member_refer #maxCommission1").html(responseJSON["maxCommission"]);
                $("#member_refer #maxCommission2").html($("#member_refer #maxCommission2").html().replace("1000",responseJSON["maxCommission"]));
                $("#member_refer #referrer-text").html(responseJSON["link"]);
                $("#member_refer #regs").html(responseJSON["regs"]);
                $("#member_refer #refs").html(responseJSON["refs"]);
                $("#member_refer #stats_count").html(responseJSON["payments"].length);

                let statHtml= '';
                for (var i = 0; i < responseJSON["payments"].length; i++) {
                    statHtml+='<p class="tw-text-sm tw-font-normal tw-inline tw-m-0 tw-leading-[1.48] tw-text-[white] " >\n' +
                        responseJSON["payments"][i]["first_payment_at"] + ' - '+ parseInt(responseJSON["payments"][i]["commission_credit"])+' '+this.helpers.getTranslate('popup_member_referer_bottom_table_line')+'\n' +
                        '            </p>';
                }

                if(statHtml===''){$("#member_refer .member-referer-stats").hide();}

                $("#member_refer #stats").html(statHtml);
                $("#member_refer").removeClass("hidden");
            });
        }

        _openAchievements(){
            $("#achievements").removeClass("hidden");
            $("#wait").show();
            $.ajax({  url: '/ajax/api/popup/achievements', type: 'POST', dataType: 'html', data: {  },
                complete:function(){
                    $("#wait").hide();
                },
                success: function(data) {
                    $("#achievements").html(data+'');
                    $("#wait").hide();
                    $('#achievements .linked').removeClass("linked");
                    if(window.location.href.indexOf("#achievements_")!==-1){
                        let achivement = window.location.href.split("#achievements_")[1];
                        $('#achievements').animate({scrollTop: $("#achievements_"+achivement).offset().top}, 300), function() {};
                        $("#achievements_"+achivement).addClass("linked");
                    }
                    if(window.location.href.indexOf("#achievements")===-1){
                        window.history.pushState({},"", window.location.href+"#achievements");
                    }
                },
                error: function(err) {
                    $("#wait").hide();
                    console.error(err)
                    $("#achievements").addClass("hidden");
                }
            });
        }

        _closeAchievements(){
            $("#achievements").addClass("hidden");
            window.history.replaceState('', '', '/live');
        }

        _rendersmallPromo(_thisObj,responseJSON){
            if(!this.smallPromoIsOn){return;}
            let thisref=this;
            // @ts-ignore
            if(/*__isLoggedMember  === true &&*/ responseJSON.result_small === true && $('#roomlist .small-promo').length==0 ){
                if($("#small_promo_include").text()==="" && window["cookie"].read("small_promo")==="1"){return;}
                if($("#small_promo_include").text()!=="" && window["cookie"].read("small_promo_extend")===$("#small_promo_include").attr("data-template")){return;}

                // @ts-ignore
                let imgElement = $('<img>').attr('src', '/design/default/babes/images/promo/small/'+__currLang+'/'+this.helpers.GetRand(1,21)+'.png?v=1');
                let aElement = $('<a>').attr('href', 'javascript:void(0)');
                let closeElement = $('<div>').addClass('close');
                closeElement.click((e) => {
                    if($("#small_promo_include").text()===""){window["cookie"].create("small_promo", "1") ;}
                    else{
                        window["cookie"].erase("small_promo_extend");
                        window["cookie"].create("small_promo_extend", $("#small_promo_include").attr("data-template"));
                    }

                    $('#roomlist .small-promo').remove();
                    _thisObj._addlastrooms_if_required(true);
                });
                let parentElement= $('<div>').addClass('room');
                let innerElement= $('<div>').addClass('room-inner');
                if($("#small_promo_include").text()!=="") {
                    innerElement.click((e) => {
                        // @ts-ignore
                        smallPromoClickFunction();
                    });
                }else{
                    innerElement.click((e) => {
                        // @ts-ignore
                        if(__isLoggedMember !== true){
                            _thisObj.babesHandler.showPopup('loginpop');
                        }else {
                            thisref._opensmallPromo();
                        }
                    });
                }
                let infoElement= $('<div>').addClass('info');
                parentElement.append(innerElement);

                if($("#small_promo_include").text()!==""){
                    aElement=$("#small_promo_include").clone();
                    aElement.removeClass("hidden");

                    infoElement.append(closeElement);
                    innerElement.append(aElement);
                    innerElement.append(infoElement);
                }
                else{
                    infoElement.append(aElement);infoElement.append(closeElement);
                    innerElement.append(imgElement);innerElement.append(infoElement);
                }

                let liElement = $('<li>').addClass('promo').addClass('small-promo').append(parentElement);
                $('#roomlist').prepend(liElement);
                _thisObj._addlastrooms_if_required(true);
            } else if(responseJSON.result_small === false) {
                if($ ('#roomlist .small-promo').length>0){
                    $('#roomlist .small-promo').remove();
                    _thisObj._addlastrooms_if_required(true);
                }
            }
        }

        /**************************************************************************/

        /**
         * Rendereli a szoba listát
         */
        private last_renderroomlist_timestamp=6000;
        private lastrender_timout=-1;
        _renderRoomList(nicereload=false, forced=false) {

            let thisref=this;
            $("#main .content-loading").hide();

            if(this.fullRoomList == null || this.fullRoomList.length==0) { return; }
            if(!$("section.onlineroom-section").is(":visible") || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen") || window.location.href.indexOf("/mypage/")!==-1){return;}
            //onsole.helpers.log("Rendering roomlist?"+(new Date().getTime()-thisref.last_renderroomlist_timestamp));
            if(new Date().getTime()-thisref.last_renderroomlist_timestamp<200){
                try{clearTimeout(thisref.lastrender_timout);}catch (e) { }
                // @ts-ignore
                thisref.lastrender_timout=setTimeout(function () {    thisref._renderRoomList(nicereload,forced);  },350);
                return;
            }else{
                try{clearTimeout(thisref.lastrender_timout);}catch (e) { }
            }
            thisref.last_renderroomlist_timestamp=new Date().getTime();
            this.helpers.log("Rendering roomlist.");

            let islastpage=(thisref.currentPage>=thisref._maxpage);
            if(!nicereload && !forced){thisref.currentPage = thisref.currentPage + 1;}

            let startIndex = $('#roomlist').find('li.room-item:not(.duplicate)').length /*- ((this.renderedHappyHour) ? 1 : 0)*/;
            if(nicereload || forced){startIndex=0;}
            let endIndex   = startIndex + this._configPerPage /*- ((this.renderedHappyHour && this.currentPage == 1) ? 2 : 0)*/;
            if(nicereload){
                endIndex=startIndex + this._configPerPage*(this.currentPage-1);
                //endIndex=$('#roomlist').find('li.room-item:not(.hidden)').length;
            }
            if(forced){endIndex=startIndex + this._configPerPage*this.currentPage;}

            this.renderedRoomNum     = 0;

            $.each(this.fullRoomList.slice(startIndex, endIndex), (itemIndex, roomData) => {
                this._generateRoomItem(roomData,nicereload);
            });
            if(!nicereload){
                this._BigroomPlacer();
                this._StartStreamsRandom();
            }

            this.autoPagingScrollTop = $('footer').offset().top;

            $('#roomlist'+(nicereload?"_preload":"")).css('min-height', '');

            if(!nicereload && islastpage){
                thisref._addlastrooms_if_required(true);
            }
        }

        /**************************************************************************/

        /**
         * Lekérdezi a szobák listáját
         */
        _getRoomList() {
            let _thisObj = this;

            return new Promise<void>((resolve, reject) => {
                try {
                    $.ajax({
                        url      : '/ajax/api/roomList/babes?hideoff=1',
                        type     : 'GET',
                        dataType : 'json',
                        data     : {}
                    }).done((responseJSON) => {
                        _thisObj.fullRoomList = responseJSON; resolve();

                        //feketelistások leghátulra
                        let tolast=_thisObj.fullRoomList.filter(function( obj ) { return obj.achievements.indexOf("blacklist") !== -1; });
                        _thisObj.fullRoomList = _thisObj.fullRoomList.filter(function( obj ) { return obj.achievements.indexOf("blacklist") === -1 ; });
                        _thisObj.fullRoomList = _thisObj.fullRoomList.concat(tolast);

                    });
                } catch(ex) { reject(); }
            });
        }

        /**
         * Legenerálja a szobák listáját és beilleszti a DOM fába
         */
        _generateRoomItem(roomData,nicereload=false) {
            let modeElement = $('<div>').addClass('mode').html(this._textRoomMode(roomData.onlinestatus));
            let nameElement = $('<div>').addClass('name').html(roomData.screenname);
            let infoElement = $('<div>').addClass('info').append(modeElement).append(nameElement);

            let smartToyElement = $('<div>').addClass('smarttoy').addClass("hidden");
            infoElement.append(smartToyElement);

            // @ts-ignore
            if(__isLoggedMember === true) {
                let favoriteElement = $('<a>').addClass('favorite').attr('title', this.helpers.getTranslate('mypagedisplay_addfavorite')).attr('href', 'javascript:void(0)').data('perfid', roomData.perfid);

                if(roomData.isFavorite === true) {
                    favoriteElement.addClass('on').attr('title', this.helpers.getTranslate('mypagedisplay_delfavorite'));
                }

                infoElement.append(favoriteElement);
            }

            let linkElement     = $('<a>').attr('href', '/mypage/'+roomData.perfid+'/'+roomData.screenname+'/chat');
            //let linkElement     = $('<a>').attr('href', '/babes/chat?id='+roomData.perfid);
            let muteLinkElement = $('<a>').addClass('sound').click((e) => {
                                      if($(e.target).hasClass("on")) { $(e.target).removeClass('on'); } else { $(e.target).addClass('on'); }
                                      let videoElement = <HTMLVideoElement>document.getElementById('video_'+roomData.perfid); videoElement.muted = !videoElement.muted;
                                  });
            infoElement.append(linkElement).append(muteLinkElement);

            let imgElement      = $('<img>').attr('src', roomData.roomimgid).attr('alt', roomData.screenname).attr('data-id', 0).attr('data-big-img', roomData.roomimgid_big).attr('onerror', "$('.room-item-"+roomData.perfid+"').addClass('hidden');roomListNG._addlastrooms_if_required(true);");
            let innerDivElement = $('<div>').addClass('room-inner').append(imgElement).append(infoElement);
            let roomDivElement  = $('<div>').addClass('room').append(innerDivElement);
            let mainElement     = $('<li>').addClass('room-item').addClass('room-item-'+roomData.perfid).addClass('page-'+this.currentPage).attr("data-achivements",roomData.achievements.join(" ")).attr("data-special",roomData.special_flag).append(roomDivElement);

            linkElement.click(() => {
                this.roomView._openPerformerFullscreen(roomData);
                /*var win = window.open('/mypage/'+roomData.perfid+'/'+roomData.screenname+'/chat', '_self');
                win.focus();*/
                return false;
            });

            if(roomData.special_flag && roomData.special_flag == 'pom') {
                let pomTextElement = $('<div>').addClass('pomtext').html(this.helpers.getTranslate('pom_text_normal').split('|').join('').replace('{{month}}', '').replace('{{screenname}}', ''));

                mainElement.addClass('pom').prepend(pomTextElement);
            }

            mainElement.addClass('room-mode-'+roomData.onlinestatus);
            mainElement.data('perfid', roomData.perfid);

            this._bindStreamPreview(mainElement);

            $('#roomlist'+(nicereload?"_preload":"")).append(mainElement);

            this.renderedRoomNum++;
        }


        /**
         * Bigroomok elhelyezése a grid szabályoknak megfelelően
         */
        _BigroomPlacer(replaceFirstXBigroomToPremium=true,mainelement="#roomlist",childelement=".room-item",bigroomclass="bigroom",sordbMainElement="", replaceFirstXBigroomToVertical = false) {
            //hány oszlop van 1 sorban
            let sordb=this._getColcountPerRow((sordbMainElement==""?mainelement:sordbMainElement)+' '+childelement);
            if(sordb==1){return;}
            console.log("_BigroomPlacer" + replaceFirstXBigroomToPremium +" "+mainelement+" "+childelement+" "+bigroomclass+" "+sordbMainElement);

            //alap paraméterek
            let spacebetweenbigrooms=this.spacebetweenbigrooms;
            let bigroomrowsize=this.bigroomrowsize;
            let bigroomcolsize=this.bigroomcolsize;
            let maxbigrooms=99999;
            if(mainelement=="#roomlist"){maxbigrooms=2;}
            let elements=$(mainelement+' '+childelement+':not(.brready,.hidden)').not("[data-achivements*='blacklist']").not("[data-vertical*='true']");
            let thisref=this;
            let rowdiffsum=spacebetweenbigrooms+bigroomrowsize;
            let brcounter=$(mainelement+' '+childelement+'.brready').length+1;
            let startrow=this.bigroomstartrow;
            if($(mainelement+" .top-right-promo").length>0){startrow=startrow+2;}
            else if($(mainelement+" .happy-hour-promo").length>0){startrow++;}

            let bigrooms = $(mainelement+' '+childelement+'.'+bigroomclass+'');
            let lastbigrstartrowMax = 0;
            bigrooms.each(function () {
                if(parseInt($(this).attr( "data-row"))>lastbigrstartrowMax){ lastbigrstartrowMax = parseInt($(this).attr( "data-row"));}
            });

            let lastbigrstartrow=bigrooms.length>0?lastbigrstartrowMax:startrow-rowdiffsum;

            let bigcolstartvariations=[];for(var i=0;i<sordb-bigroomcolsize+1;i++){bigcolstartvariations.push(i+1);}
            let lastbigrstartcol= bigrooms.length>1?parseInt($(mainelement+' '+childelement+'.'+bigroomclass+':last').attr("data-col")):bigcolstartvariations[Math.floor((Math.random()*bigcolstartvariations.length))];
            let pluszhelyfoglalas=(bigroomrowsize*bigroomcolsize)-1;
            this.helpers.log("Bigrooms add: "+mainelement+" "+childelement+" "+bigroomclass+" brcounter:"+brcounter+", bigrooms: "+$(mainelement+' '+childelement+'.'+bigroomclass+'').length+", lastbigrstartrow: "+lastbigrstartrow+" elements:"+elements.length+" sordb:"+sordb+" ");

            //pozícionálás
            elements.each(function () {
                if($(mainelement+' '+childelement+'.'+bigroomclass).length<maxbigrooms){ _BigroomAdd($(this));}
            });

            bigrooms = $(mainelement+' '+childelement+'.'+bigroomclass+'');
            if(replaceFirstXBigroomToPremium){this.replaceFirstXBigroomToPremium(2,mainelement,childelement,bigroomclass);}
            if(replaceFirstXBigroomToVertical){this.replaceFirstXBigroomToVertical(bigrooms.not("[data-vertical*='true']").length,mainelement,childelement,bigroomclass);}

            /**
             * Bigroom elhelyezése
             */
            function _BigroomAdd(element) {
                let curr_row=Math.ceil((brcounter+$(mainelement+' '+childelement+'.'+bigroomclass+'').length*pluszhelyfoglalas)/sordb);
                let curr_pos=(brcounter+$(mainelement+' '+childelement+'.'+bigroomclass+'').length*pluszhelyfoglalas)%sordb;
                if(curr_pos==0){curr_pos=sordb;}

                thisref.helpers.log("Bigroom add: lastbigrstartrow:"+lastbigrstartrow+" rowdiffsum:"+rowdiffsum+" curr_row:"+curr_row+" sordb:"+sordb+" ");
                if( lastbigrstartrow+rowdiffsum==curr_row){
                    thisref.helpers.log("Bigroom add reaplly: lastbigrstartrow:"+lastbigrstartrow+" rowdiffsum:"+rowdiffsum+" curr_row:"+curr_row+" sordb:"+sordb+" ");
                    element.addClass(bigroomclass);
                    element.find("img:first").attr('src',element.find("img:first").attr("data-big-img"));
                    //thisref._bindStreamPreviewEnter(element.data("perfid"), true);

                    lastbigrstartrow=curr_row;
                    element.css("grid-row-start",curr_row+"");

                    let colvariants = bigcolstartvariations.filter(function(elem){//csak 1 oszlopnyi eltérés lehet
                        return ((elem != lastbigrstartcol && Math.abs(elem-lastbigrstartcol)==1) || sordb<=2);
                    });

                    let currcol=colvariants[Math.floor((Math.random()*colvariants.length))];
                    lastbigrstartcol=currcol;
                    element.css("grid-column-start",currcol+"");

                    element.attr("data-col",currcol+"");
                    element.attr("data-row",curr_row+"");
                }

                element.addClass("brready");
                brcounter++;
            }
        }

        /**
         * Bigroom cseréje
         */
        replaceFirstXBigroomToPremium(x,selectorroomlist="#roomlist",child=".room-item",bigrclass="bigroom") {
            for(let i=0;i<x;i++){
                let old=$(selectorroomlist+" "+child+"."+bigrclass).eq(i);
                if((typeof old.attr("data-achivements") == 'undefined' || old.attr("data-achivements").indexOf("premium") === -1)
                    || (typeof old.attr("data-achivements") != 'undefined' && old.attr("data-achivements").indexOf("premium")!==-1 &&
                        (old.hasClass("room-mode-offline") || !old.hasClass("room-mode-free") )) ){
                    let colorig=old.attr("data-col");
                    let roworig=old.attr("data-row");
                    let newpremiums=$(selectorroomlist+" "+child+".room-mode-free[data-achivements*='premium']:not(.bigroom)").not(".room-mode-offline").not("[data-achivements*='blacklist']");
                    if(newpremiums.length==0){
                        newpremiums=$(selectorroomlist+" "+child+"[data-achivements*='premium']:not(.bigroom)").not(".room-mode-offline").not("[data-achivements*='blacklist']");
                    }
                    if(newpremiums.length==0){
                        newpremiums=$(selectorroomlist+" "+child+"[data-achivements*='premium']:not(.bigroom)").not("[data-achivements*='blacklist']");
                    }
                    if(newpremiums.length>0){
                        let newpremium=newpremiums.eq(this.helpers.GetRand(0,newpremiums.length-1));
                        //replace
                        newpremium.css("grid-column-start",colorig);
                        newpremium.attr("data-col",colorig);
                        newpremium.css("grid-row-start",roworig);
                        newpremium.attr("data-row",roworig);
                        newpremium.addClass(bigrclass);
                        newpremium.find("img:first").attr('src',newpremium.find("img:first").attr("data-big-img"));
                        old.removeAttr("style");
                        old.removeAttr("data-col");
                        old.removeAttr("data-row");
                        old.removeClass(bigrclass);
                    }
                }
            }
        }

        /**
         * Bigroom cseréje állóra, ha van
         */
         replaceFirstXBigroomToVertical(x,selectorroomlist="#roomlist",child=".mg-item",bigrclass="bigbox") {
            console.log("replaceFirstXBigroomToVertical "+selectorroomlist+" "+child+"."+bigrclass+" "+x);
            for(let i=0;i<x;i++){
                console.log("replaceFirstXBigroomToVertical" + i);
                let old=$(selectorroomlist+" "+child+"."+bigrclass).not("[data-vertical*='true']").eq(i);
                if(typeof old != 'undefined' && (typeof old.attr("data-vertical") == 'undefined' || old.attr("data-vertical").indexOf("true") === -1) ){
                    console.log("replaceFirstXBigroomToVertical" + i + "true");
                    let colorig=old.attr("data-col");
                    let roworig=old.attr("data-row");
                    let newpremiums=$(selectorroomlist+" "+child+"[data-vertical*='true']:not(."+bigrclass+")");
                    if(newpremiums.length>0 && parseInt(colorig)>0){
                        console.log("replaceFirstXBigroomToVertical replaced" + newpremiums.length);
                        let newpremium=newpremiums.eq(0);
                        //replace
                        newpremium.css("grid-column-start",colorig);
                        newpremium.attr("data-col",colorig);
                        newpremium.css("grid-row-start",roworig);
                        newpremium.attr("data-row",roworig);
                        newpremium.addClass(bigrclass);
                        newpremium.addClass("bigbox-vertical");
                        newpremium.find("img:first").attr('src',newpremium.find("img:first").attr("data-big-img"));
                        old.removeAttr("style");
                        old.removeAttr("data-col");
                        old.removeAttr("data-row");
                        old.removeClass(bigrclass);
                    }
                }
            }
        }

        /**
         * Streamek véletlen indítása (kb. 3 soronként 1)
         */
        _StartStreamsRandom() {
            if(window.location.href.indexOf("/mypage/")!==-1){return;}

            let sordb=this._getColcountPerRow('#roomlist .room-item');
            let elements=$('#roomlist .room-item:not(.asready,.hidden)');
            if(elements.length<25){return;}

            let brcounter=1;
            let laststartindex=1;
            let thisref=this;
            let room = thisref.helpers.getCurrentRoomidFromChat();
            //let firshelper=thisref.helpers.GetRand(0, 2);
            elements.each(function () {
                if( $(this).hasClass("room-mode-free") /*&& ($(this).attr("data-achivements").indexOf("premium")!==-1 || $(this).attr("data-achivements").indexOf("MEMBER_FAVORITE")!==-1)*/
                        && (thisref.lastRandomFreeRoom==null || thisref.lastRandomFreeRoom.roomid!=$(this).data("perfid"))
                        && (room === null || room != $(this).data("perfid")  )
                        && (
                            (($(this).attr("data-achivements").indexOf("premium")!==-1 || $(this).attr("data-achivements").indexOf("MEMBER_FAVORITE")!==-1) && (laststartindex==1 || brcounter-laststartindex>thisref.helpers.GetRand(sordb*2,sordb*2.5)) )
                            || (laststartindex==1 /*&& firshelper==brcounter%3*/)
                            || brcounter-laststartindex>thisref.helpers.GetRand(sordb*2.5,sordb*3)
                            //|| ($(this).hasClass("bigroom") && thisref.helpers.GetRand(1,3) >1 )

                        )
                    ){
                    $(this).addClass("autostart");
                    thisref._bindStreamPreviewEnter($(this).data("perfid"), true);
                    laststartindex=brcounter;
                }
                $(this).addClass("asready");
                brcounter++;
            });
        }



        /**
         * Visszaadja hány oszlop van egy sorban
         */
        _getColcountPerRow(selector) {
            let sordbcounter=1;let sordb=0;let lastpos=-1;
            $(selector).each(function(i){
                let current= $(this).position().top;
                if(current!=lastpos){sordbcounter=1;}
                else{sordbcounter++;}
                if(sordbcounter>sordb){sordb=sordbcounter;}
                lastpos=current;
            });
            return sordb;
        }

        /**
         * Ellenőrzi és visszaadja a smarttoy-t (ha van), szoba adatok alapján
         */
        _getSmartToyByRoomData(roomData) : string|boolean {
            if(typeof roomData.onlineParams == 'undefined' || roomData.onlineParams == null || typeof roomData.onlineParams.publicData == 'undefined' || typeof roomData.onlineParams.publicData.lovenseOnline == 'undefined') { return false; }
            return roomData.onlineParams.publicData.lovenseOnline==="1";
        }

        /**************************************************************************/

        /**
         * Elindítja a kép cserélés időzítőt
         */
        _startRoomPictureTimer() {
            setInterval(() => {
                if(this.focusedPage === false) { return; }

                let maxPerformerCount = this._configPerPage * this.currentPage;

                let randomPerformerIndex = Math.floor(Math.random() * maxPerformerCount);
                let randomPerformerData = this.fullRoomList[randomPerformerIndex];

                try{this._changeRoomPicture(randomPerformerData.perfid);}catch(ex){}
            }, 6000);
        }

        /**
         * Galéria megnyitása
         */
        public _changeRoomPicture(performerId) {
            if(this.nicereloading_in_progress){return;}

            let roomData = this._getRoomDataByPerfId(performerId);

            let performerPictureObj = $('.room-item-'+performerId).find('img');

            if(typeof roomData.newImages == 'undefined' || roomData.newImages.length == 0 || roomData.newImages.length <= parseInt(performerPictureObj.attr('data-id')) + 1) { return; }

            let randomPicture = roomData.newImages[parseInt(performerPictureObj.attr('data-id')) + 1];

            performerPictureObj.attr('data-id', parseInt(performerPictureObj.attr('data-id')) + 1);

            if(performerPictureObj.attr('src') == randomPicture.img_url) { return; }

            new Image().src = randomPicture.img_url;  // Preload Image
            setTimeout(() => {  // vár 2mp, hogy be tudja tölteni a képet
                performerPictureObj.animate({
                    opacity: 0.5
                }, 800, () => {
                    performerPictureObj.attr('src', randomPicture.img_url);
                    performerPictureObj.animate({opacity: 1}, 800);
                });
            }, 3000);
        }

        /**************************************************************************/

        /**
         * Előlnézeti stream megnyitásának bindelése
         */
        public current_active_perf_id=-1;
        private last_hover_ts=0;
        private mouse_enter_timeout=0;
        _bindStreamPreview(domElement) {
            try {
                let _thisObj = this;

                domElement.on('mouseenter', function() {
                     _thisObj.current_active_perf_id=domElement.data('perfid');
                     try { clearTimeout(_thisObj.mouse_enter_timeout); } catch (ex2) {}
                    // @ts-ignore
                    _thisObj.mouse_enter_timeout=setTimeout(() => { _thisObj._bindStreamPreviewEnter(domElement.data('perfid'));}, 100);
                }).on('mouseleave', function() {
                    _thisObj.current_active_perf_id=-1;
                    try { clearTimeout(_thisObj.mouse_enter_timeout); } catch (ex2) {}
                    _thisObj.helpers.log("tryleave mouseleave "+domElement.data('perfid'));
                    _thisObj._bindStreamPreviewLeave(domElement.data('perfid'));
                });
            } catch (ex) {}
        }

        /**
         * Előlnézeti stream megnyitásának bindelése
         */
        _bindStreamPreviewEnter(performerId, autoStartPreview = false) {
            let _this=this;

            $.ajax({
                url      : 'https://chat.a.apn2.com/chat-api/index.php/chatPreview/getRoom',
                type     : 'GET',
                dataType : 'json',
                data     : { "tokenID": "guest", "roomID": performerId }
            }).done((responseJSON) => {
                try {
                    if (_this._getSmartToyByRoomData(responseJSON.data) !== false) {  // Ha van smarttoy eszköze, akkor az ikont hozzáadja
                        $(".room-item-" + performerId + " .info .smarttoy").removeClass("hidden");
                    } else {
                        $(".room-item-" + performerId + " .info .smarttoy").addClass("hidden");
                    }
                } catch (ex) {
                    console.error(ex);
                }
            });

            if($('#video_' + performerId).length != 0 && $('#video_' + performerId).hasClass('auto-preview')) { return; }
            //this._addLoadingIconToRoom(performerId);  // Töltő ikon hozzáadása a szobához

            if(autoStartPreview === false) {this._currentPreiviewPerformer = performerId; }
            this._bindStreamPreviewEnterCallback(performerId, autoStartPreview, this);
        }

        /**
         * Előlnézeti stream megnyitásának bindelése
         */
        _bindStreamPreviewEnterCallback(roomID, autoStartPreview, _thisObj) {
            try {
                let _this=this;
                this.helpers.log("tryenter:"+roomID);
                //this.helpers.log(responseJSON);
                //if(typeof responseJSON.data.onlineParams == 'undefined' || typeof responseJSON.data.onlineParams.modeSpecific == 'undefined' || typeof responseJSON.data.onlineParams.modeSpecific.main == 'undefined' || typeof responseJSON.data.roomID == 'undefined') { return; }

                var performerId = roomID;

                this.helpers.log("enter:"+performerId);

                if(autoStartPreview === false && _this._currentPreiviewPerformer != performerId) { return; }

                /*$('.room-item-'+performerId).find('.room-inner').append('<video id="video_'+performerId+'" style="z-index: 5; width: 100%;"></video>');
                if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }
                var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);*/


                if(_this._hlsSupport || true) {
                    this.helpers.log("entering _hlsSupport:"+performerId);
                    $('.room-item-'+performerId).find('.room-inner').append('<div id="video_'+performerId+'" style="z-index: 5; width: 100%;"><div class="stream"></div></div>');
                    if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }

                    this.fillAndStream($("#video_"+performerId),roomID,"https://chat.a.apn2.com/chat-api/index.php/");
                } else{
                    $('.room-item-'+performerId).find('.room-inner').append('<video id="video_'+performerId+'" style="z-index: 5; width: 100%;"></video>');
                    if(autoStartPreview === true) { $('#video_' + performerId).addClass('auto-preview'); }
                    var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);

                    if( videoObject.canPlayType('application/vnd.apple.mpegurl')){
                        $.ajax({
                            url      : 'https://chat.a.apn2.com/chat-api/index.php/chatPreview/getRoom',
                            type     : 'GET',
                            dataType : 'json',
                            data     : { "tokenID": "guest", "roomID": performerId }
                        }).done((responseJSON) => {

                            const streamUrl = responseJSON?.data?.onlineParams?.modeSpecific?.main?.hls?.address;

                            if (streamUrl) {
                                this.helpers.log("hls:"+performerId+" "+streamUrl);

                                this.helpers.log("nohls:"+performerId+" "+streamUrl);
                                videoObject.src = streamUrl;
                                videoObject.addEventListener('loadedmetadata',function() { videoObject.muted = true; videoObject.play(); /*_thisObj._removeLoadingIconToRoom(performerId);*/ });
                            }
                        });
                     }
                }
            } catch (ex) { $("#room-item-"+roomID).removeClass("autostart"); this.helpers.log(ex); /*_thisObj._removeLoadingIconToRoom(performerId);*/ }
        }

        /*Stream join segéd függvények */
        private rpwin=[];
        private fillAndStream = ($box, roomid, apiURL) =>
        {
            let thisref=this;
            if(!(typeof this.rpwin[roomid] === "undefined" || this.rpwin[roomid]==null)){return;}
            thisref.helpers.log("ROOM", roomid);
            this.rpwin[roomid] = new window["SxcChatPreview"]($box.find(".stream")[0], {
                apiURL: apiURL
            });

            thisref.helpers.log("ROOM preview load complete", roomid);
            this.rpwin[roomid].setVolume(0);

            this.rpwin[roomid].showRoom(roomid, (mode) =>
            {
                thisref.helpers.log("showROOM", mode);
                if (mode !== "free" && mode !== "end") {
                    if (this.rpwin[roomid]) {this.rpwin[roomid] = null;}
                    $box.find(".stream").empty();
                }

                if((roomid+"").indexOf("v")===-1){
                    $(".room-item-"+roomid).removeClass (function (index, className) {
                        return (className.match (/room-mode-([a-z])+/g) || []).join(' ');
                    }).addClass("room-mode-"+mode);
                    $(".room-item-"+roomid+" .info .mode").text(this._textRoomMode(mode));
                }
            });
        };
        private clearAndStop = ($box,performerId) => {
            if(typeof this.rpwin[performerId] === "undefined" || this.rpwin[performerId]==null){return;}
            this.rpwin[performerId].cancel(() => {
                this.helpers.log("ROOM END "+performerId);
                this.rpwin[performerId]=null;
                $box.find(".stream").empty();
                $box.find("img").hide();
            });
        };

        /**
         * Előlnézeti stream bezárás bindelése
         */
        private laststop_performerid=-1;
        private laststop_performer_timestamp=new Date().getTime();
        _bindStreamPreviewLeave(performerId, forceStopPreview = false) {
            this.helpers.log("tryleave:"+performerId);
            if((performerId==this.laststop_performerid && new Date().getTime()-this.laststop_performer_timestamp<500) || typeof performerId == 'undefined'){return;}
            this.helpers.log("leave:"+performerId);
            this.laststop_performerid=performerId;
            this.laststop_performer_timestamp=new Date().getTime();
            if($('#video_' + performerId).length != 0 && $('#video_' + performerId).hasClass('auto-preview') && forceStopPreview === false) { return; }
            //this.helpers.log("Destroy:"+performerId);

            try {
                this._currentPreiviewPerformer = null;

                //this._removeLoadingIconToRoom(performerId);  // Törli a töltő ikont a szobáról

                if(this._hlsSupport) {
                    this.clearAndStop( $('#video_' + performerId),performerId);
                    /*this._hlsObject[performerId] && this._hlsObject[performerId].destroy();
                    this._hlsObject[performerId] = null;*/
                } else {
                    var videoObject : HTMLVideoElement = <HTMLVideoElement>document.getElementById('video_'+performerId);
                    videoObject.pause();
                }
            } catch (ex) {}

            $('#video_' + performerId).remove();
        }

        /**************************************************************************/

        /**
         * Lapozó gomb felbindelése
         */
        _bindPagingLink() {
            let thisref=this;
            $('.roomlist-paging').click(() => {
                if(!$("section.onlineroom-section").is(":visible") || thisref.nicereloading_in_progress || $("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){return;}
                if(thisref.currentPage<=thisref._maxpage){
                    thisref._renderRoomList();
                }/*else{
                    $(".roomlist-paging").show();
                }*/
            });
        }

        /**************************************************************************/

        /**
         * Töltő ikon hozááadása a szobához
         */
        _addLoadingIconToRoom(performerId) {
            //$('#room_'+performerId).find('.room').addClass('loading');
            if($('.room-item-'+performerId ).length>0 && $('.room-item-'+performerId ).hasClass("room-mode-free")){
                $('#wait').css("position","absolute");
                $('#wait').appendTo($('.room-item-'+performerId  )[0]);
                $("#wait").show(  );
                $('#wait').css("display","block");
            }
        }

        /**
         * Töltő ikon törlése a szobáról
         */
        _removeLoadingIconToRoom(performerId) {
            //$('#room_'+performerId).find('.room').removeClass('loading');
            $('.room-item-'+performerId+" #wait").hide();
        }

        /**************************************************************************/

        /**
         * Visszaadja a szoba állaponák megfelelő szöveget
         */
        _textRoomMode(roomMode : string) : string {
            try {
                // @ts-ignore
                if (typeof babes_roommodes == 'undefined') {
                    console.error("babes_roommodes not defined");
                    return 'Offline';
                }

                // @ts-ignore
                if('roomcomp_type_'+roomMode in babes_roommodes) {
                    // @ts-ignore.blockedcontent .box img
                    return babes_roommodes['roomcomp_type_'+roomMode];
                } else {
                    console.error("Not recognised roomode: "+roomMode);
                    // @ts-ignore
                    return babes_roommodes['roomcomp_type_offline'];
                }
            } catch (e) {console.error(e); return 'Offline'; }
        }

        /**************************************************************************/

        _getRoomDataByPerfId(performerId) {
            let responseRoomData;

            $.each(this.fullRoomList, (itemIndex, roomData) => {
                if(roomData.perfid == performerId) {
                    responseRoomData = roomData;

                    return false;
                }
            });

            return responseRoomData;
        }



        addBigroomsAndLAstroomsInPopup(parentelement,profilePage,profileMediaMaxPage,sordbparentelement="") {
            this._BigroomPlacer(false,parentelement+" .mediagallery",".mg-item","bigbox",sordbparentelement==""?parentelement:sordbparentelement, true);
            this.helpers.log("Lastroom add before (popup) "+profilePage+" "+profileMediaMaxPage);
            if(profilePage >= profileMediaMaxPage){
                this.helpers.log("Lastroom add (popup) "+profilePage+" "+profileMediaMaxPage);
                this._addlastrooms_if_required(true,parentelement+" .mediagallery",".mg-item","bigbox","",sordbparentelement==""?parentelement:sordbparentelement);
            }
        }

        addBigroomsAndLAstroomsInPopupFanclub(parentelement,profilePage,profileMediaMaxPage,sordbparentelement="") {
            this._BigroomPlacer(false,parentelement+"",".mg-item","bigbox",sordbparentelement==""?parentelement:sordbparentelement, true);
            this.helpers.log("Lastroom add before (popup) "+profilePage+" "+profileMediaMaxPage);
            if(profilePage >= profileMediaMaxPage){
                this.helpers.log("Lastroom add (popup) "+profilePage+" "+profileMediaMaxPage);
                this._addlastrooms_if_required(true,parentelement+"",".mg-item","bigbox","",sordbparentelement==""?parentelement:sordbparentelement);
            }
        }



        /*Chat alapú toast üzenet*/
        private toast_timout=-1;
        showToast(message="",floattype=false){
            window["chatClient"].app.view.toastManager.push( message,{timeout: 5000, instant: true, strong: true, floattype: floattype} );
        }


        /* show registration panel if we are on the /live site (no chat present) and it is requested */
        autoShowRegisterPanel() {
            // @ts-ignore
            if (window.location.pathname === '/live' && window.chatParamsGlobal.autoShowRegister && window.chatParamsGlobal.auth.tokenID === 'guest') {
                // @ts-ignore
                window.chatParamsGlobal.autoShowRegister = false;
                this.babesHandler.showPopup('regpop');
            }
        }

        /*mobile menu close*/
        public closeMobileMenu(){
            $('#usermenu').hide();setTimeout(function(){$('#usermenu').removeAttr("style");$('#usermenu').show();},100);
        }

        /*get favorites*/
        last_favourites="";
        public getFavourites(){
            let thisref=this;
            $.getJSON("/ajax-favourites").done(function(r) {
                let num=$(r.favouritesHTML).find("li").length;
                if(num>0){
                    $("#menu_li_fav").show();
                }else{
                    $("#menu_li_fav").hide();
                }
                thisref.last_favourites=r.favouritesHTML;
            });
        }


    }

}

